export enum AssociateTypes {
   RUNNER = "Corredor",
   OWNER = "Propietario",
   REFERRED = "Referido",
   CAD = "CAD",
}
